// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-img[data-v-4263c2f0]{height:300px;-o-object-fit:cover;object-fit:cover;width:100%}", "",{"version":3,"sources":["webpack://./resources/js/Components/CanvasElement/CanvasElementCard.vue"],"names":[],"mappings":"AAAA,2BAAqB,YAAA,CAAa,mBAAA,CAAA,gBAAA,CAAxB,UAIV","sourcesContent":[".card-img{width:100%;height:300px;object-fit:cover}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
